import { render } from "./TheBbActions.vue?vue&type=template&id=206ddd2e"
import script from "./TheBbActions.vue?vue&type=script&lang=js"
export * from "./TheBbActions.vue?vue&type=script&lang=js"
script.render = render

export default script